import { Box } from "@mui/material";
import TagInput from "../../components/tags/TagInput";

export default function TagInputDemo() {
  return (
    <Box display="flex" gap={2} alignItems="center">
      <Box display="flex" flexDirection="column" gap={1}>
        <TagInput tagStyle="filled" color="inherit" size="L">
          Filled Large
        </TagInput>
        <TagInput tagStyle="filled" color="inherit" size="M">
          Filled Medium
        </TagInput>
        <TagInput tagStyle="filled" color="inherit" size="S">
          Filled Small
        </TagInput>
      </Box>

      <Box display="flex" flexDirection="column" gap={1}>
        <TagInput tagStyle="outlined" color="error" size="L">
          Outlined Large
        </TagInput>
        <TagInput tagStyle="outlined" color="error" size="M">
          Outlined Medium
        </TagInput>
        <TagInput tagStyle="outlined" color="error" size="S">
          Outlined Small
        </TagInput>
      </Box>
      <Box display="flex" flexDirection="column" gap={1}>
        <TagInput tagStyle="filled" color="overlay" size="L">
          Overlay Large
        </TagInput>
        <TagInput tagStyle="filled" color="overlay" size="M">
          Overlay Medium
        </TagInput>
        <TagInput tagStyle="filled" color="overlay" size="S">
          Overlay Small
        </TagInput>
      </Box>
      <Box display="flex" flexDirection="column" gap={1}>
        <TagInput tagStyle="rectangle" color="warning" size="L">
          Rectangle Large
        </TagInput>
        <TagInput tagStyle="rectangle" color="warning" size="M">
          Rectangle Medium
        </TagInput>
        <TagInput tagStyle="rectangle" color="warning" size="S">
          Rectangle Small
        </TagInput>
      </Box>
    </Box>
  );
}
